// extracted by mini-css-extract-plugin
export default {"container":"XSXVw","button":"_6Qhjm","isSecondary":"AqEeb","icon":"ZONwx"};